import { fetchApi } from '../../../services/apiService';
import { Loader } from '../../../components/generics/Loader';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FuelReportList from "./FuelReportList";
import Modal from "../../../components/generics/Modal";
import moment from "moment"

const FuelReportPopup = ({ filters, selectedVehicleDetails, handleModal }) => {
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const userToken = useSelector((state) => state.login.userToken);

    useEffect(() => {
        if (!selectedVehicleDetails?.vehicleId) return;
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const params = {
                    searchReportingView: 'D',
                    searchVehicleIds: selectedVehicleDetails.vehicleId.toString(),
                    fuelFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
                    fuelToDate: moment(filters?.toDate).format('YYYY-MM-DD'),
                };

                const response = await fetchApi('transactions/getFuelVouchersForReport', params, userToken);

                if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                    setTableData(response.data.fuelVouchers || []);
                } else {
                    setTableData([]);
                }
            } catch (error) {
                setTableData([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVehicleDetails?.vehicleId]);

    return (
        <div className="tyre--report--modal">
            <Modal
                updateModal={handleModal}
                isModal={true}
                headTxt={`VehicleNo: ${selectedVehicleDetails.vehicleNo} ${selectedVehicleDetails.vehicleCode ? `(${selectedVehicleDetails.vehicleCode})` : ''}`}
            >
                <div className="tyre--modal--content jc--scroll">
                    {isLoading ? (<Loader />) : (
                        <FuelReportList
                            filters={{ ...filters, searchReportingView: '2' }}
                            tableData={tableData}
                            onClose={handleModal}
                        />
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default FuelReportPopup;

